import { withPDPA } from './withPDPA'
import { PDPA } from './PDPA'

const ConnectedPDPA = withPDPA(PDPA)

export { ConnectedPDPA as PDPA }
